module.exports = __webpack_public_path__ + "img/close.a0e1fa5a.png";